import { render } from "./TratamientoForm.vue?vue&type=template&id=d9671812&scoped=true"
import script from "./TratamientoForm.vue?vue&type=script&lang=js"
export * from "./TratamientoForm.vue?vue&type=script&lang=js"

import "@/assets/css/tabs.css?vue&type=style&index=0&id=d9671812&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9671812"]])

export default __exports__